import {Address} from '../address/address.model';
import {CrudModel} from '@ngx-ivengi/crud';
import { IFormSelectOption } from '@brands-compart/form-wizard';

export class Customer extends CrudModel implements IFormSelectOption {

  public name: string;
  public address: Address = new Address();
  public contactCount: number;

  public setName(name: string): Customer {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setContactCount(contactCount: number): Customer {
    if(typeof contactCount === 'number') {
      this.contactCount = contactCount;
    }
    return this;
  }

  public fromResponse(response: any): void {
    this
      .setId(response.id)
      .setName(response.name)
      .setContactCount(response.contactCount);

    if(response.address) {
      this.address
        .setAddress(response.address.address)
        .setZip(response.address.zip)
        .setCity(response.address.city)
        .setCountry(response.address.country);
    }
  }

  toKeyValueOption(): {label: string; value: any} {
    return {
      label: this.name,
      value: this.id
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer.model.ts